import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./Modal.scss";
import modalImage from "../../assets/Modal/rupali-chairman.png";
// import { cleanup } from "@testing-library/react";

const ShowModal = ({ closeModal }) => {
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "scroll";
    };
  }, []);

  return ReactDOM.createPortal(
    <>
      <div className="modal_wrapper" onClick={closeModal}></div>

      <div className="modal_container">
        <div className="modal_close_btn_div text-end mb-3">
          <button className="btn modal_close_btn" onClick={closeModal}>
            <i className="fa-solid fa-circle-xmark"></i>
          </button>
        </div>
        <div className="modal_content">
          <img className="" src={modalImage} alt="" />
          <p>
            রূপালী ইনস্যুরেন্স কোম্পানীর লিমিটেড এর নবনির্বাচিত চেয়ারম্যান জনাব
            মোস্তফা কামরুস সোবহান স্যারকে প্রাণঢালা অভিনন্দন। রূপালী পরিবারের
            সাথে এ পথচলায় আমরা স্যারের উত্তরোত্তর সাফল্য কামনা করছি ও সর্বাত্মক
            সহযোগিতার অঙ্গীকার করছি।
          </p>
        </div>
      </div>
    </>,
    document.querySelector(".myModalDiv")
  );
};

export default ShowModal;
